export default __webpack_public_path__ + "static/media/logo-white.38fd20e6.svg";